// @ts-nocheck
import axios from 'axios';
import PubSub from 'pubsub-js';
import { EVENT_TOPIC_FORCE_LOGOUT, RESTAURANT } from '../Constants';
import { clearUserSession, getRequestConfig, handleIfUnauthorized } from '../helpers/ApiHelper';
import {
	clearContactProvidersData,
	clearToken,
	getStorage,
	STORAGE_TAG_TOKEN,
} from '../helpers/StorageHelper';
import apiConfig from '@src/config/sudoApplication';
import { store } from '@src/store';
import { isLocalHost } from '@src/helpers/URLHelper';
import { LocalStorage } from '@src/storage/LocalStorage';
import { setCurrentUser, setPermissions } from '@src/store/reducers/currentUserReducer';
import {
	setAllCatalogs,
	setAllProductsMasterCatalog,
	setSupplierCatalog,
} from '@src/store/reducers/catalogReducer';
import { setAllOrders } from '@src/store/reducers/orderReducer';
import { setCart } from '@src/store/reducers/cartReducer';
import { setBranches, setRestaurants } from '@src/store/reducers/branchReducer';
import { setAllUsers } from '@src/store/reducers/teamReducer';
import { setChats } from '@src/store/reducers/chatsReducer';
import { setCart as setMarketplaceCart, setProduct } from '@src/store/reducers/marketPlaceReducer';
import { clearApiCache } from '@src/helpers/serviceWorkerHelper';

export class ApiService {
	constructor(config) {
		console.log(window.location.hostname.split('.')[0]);
		switch (window.location.hostname.split('.')[0]) {
			case 'web-stage':
				this.config = config?.STAGE;
				this.apiBaseURL = config?.STAGE?.API_BASE_URL;
				this.apiBaseURLV2 = config?.STAGE?.API_BASE_URL_V2;
				break;
			case 'web':
				this.config = config?.PROD;
				this.apiBaseURL = config?.PROD?.API_BASE_URL;
				this.apiBaseURLV2 = config?.PROD?.API_BASE_URL_V2;
				break;
			default:
				this.config = config?.TEST;
				this.apiBaseURL = config?.TEST?.API_BASE_URL;
				this.apiBaseURLV2 = config?.TEST?.API_BASE_URL_V2;
				break;
		}
	}

	getBusinessId = () => {
		return store?.getState()?.organization?.value?.businessId;
	};

	getSupplierId = () => {
		return store?.getState()?.currentUser?.value?.userId;
	};

	getCurrentUserType = () => {
		return store?.getState()?.currentUser?.value?.type?.toLowerCase();
	};

	clearPersistedData = () => {
		const localStorage = new LocalStorage();
		localStorage.removeItem('persist:root');
		store?.dispatch(setCurrentUser({}));
		store?.dispatch(setSupplierCatalog({}));
		store?.dispatch(setAllCatalogs([]));
		store?.dispatch(setAllProductsMasterCatalog([]));
		store?.dispatch(setAllOrders({}));
		store?.dispatch(setCart({}));
		store?.dispatch(setRestaurants({}));
		store?.dispatch(setAllUsers([]));
		store?.dispatch(setBranches([]));
		store?.dispatch(setPermissions([]));
		store?.dispatch(setChats({}));
		store?.dispatch(setMarketplaceCart([]));
		store?.dispatch(setProduct(null));
	};

	getPathBeforeTokenGotExpire = () => {
		const localStorage = new LocalStorage();
		return localStorage.getItem('prevPath');
	};
	setApplicationPathBeforeTokenGotExpire = () => {
		const localStorage = new LocalStorage();
		const prevPathData = {
			path: window.location.pathname + window.location.search,
			branchId: window.location.pathname.split('/')[2],
		};
		const prevPathJSON = JSON.stringify(prevPathData);
		localStorage.setItem('prevPath', prevPathJSON);
	};

	clearSession = (errorCase) => {
		const currentHost = window.location.hostname;
		if (errorCase) {
			if (isLocalHost()) {
				window.location.href = `http://${currentHost}:3001/login/error/${errorCase}`;
			} else {
				window.location.href = `https://${currentHost}/login/error/${errorCase}`;
			}
		} else {
			window.location.href = `https://${currentHost}/`;
		}
		this.clearPersistedData();
		clearApiCache();
		this.logoutCallV2();
	};

	handleRequest = (
		promise,
		successCallback,
		errorCallback,
		completeCallback,
		willHandleAuthError,
		navigate
	) => {
		promise
			.then((response) => {
				successCallback?.(response);
				if (completeCallback) {
					completeCallback();
				}
			})
			.catch((error) => {
				errorCallback?.(error);
				if (completeCallback) {
					completeCallback();
				}

				// if (willHandleAuthError) {
				// 	this.handleAuthError(error);
				// }

				if (!this.getPathBeforeTokenGotExpire()) {
					this.setApplicationPathBeforeTokenGotExpire();
				}
				if (error.response) {
					const status = error.response.status;

					if (status === 401) {
						if (error.response.data.message === 'Expired token') {
							this.clearSession('expireToken');
							return;
						} else if (error.response.data.message === 'Invalid token') {
							this.clearSession('invalidToken');
							return;
						} else if (error.response.data.message === 'User not found') {
							this.clearSession('userNotFound');
							return;
						}
					} else if (status === 403) {
						if (error.response.data.message === 'Expired token') {
							this.clearSession('expireToken');
							return;
						} else if (error.response.data.message === 'Invalid token') {
							this.clearSession('invalidToken');
							return;
						}
					}
				}
			});
	};

	handleAuthError = (error) => {
		if (error.response) {
			if (error.response.status === 401) {
				console.warn('Unauthorized: ' + error.response.status);
				getStorage().removeItem(STORAGE_TAG_TOKEN);
				PubSub.publish(EVENT_TOPIC_FORCE_LOGOUT);
			}
		}
	};

	baseCall = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(this.apiBaseURL, getRequestConfig(id, null, null, null, null, true)),
			successCallback,
			errorCallback
		);
	};

	logoutCall = (successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/auth/logout/`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	changePasswordCall = (currentPassword, newPassword, successCallback, errorCallback) => {
		this.handleRequest(
			axios.put(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/users/password/change/`,
				{
					current_password: currentPassword,
					new_password: newPassword,
				},
				getRequestConfig(id)
			),
			successCallback,
			errorCallback
		);
	};

	listChatsCall = (
		keyword,
		chatTagId,
		limit,
		offset,
		assignedToMe,
		assignedGroup,
		cancelToken,
		successCallback,
		errorCallback,
		history
	) => {
		//DONE
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/chats/`,
				getRequestConfig(
					id,
					{
						search: keyword,
						tag_id: chatTagId,
						limit: limit,
						offset: offset,
						assigned_to_me: assignedToMe,
						assigned_group: assignedGroup,
					},
					cancelToken,
					undefined,
					0
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				//handleIfUnauthorized(error, history);
				errorCallback?.(error);
			}
		);
	};

	bulkSendCall = (body, successCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/bulk_messages/`,
				body,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	listUsersCall = (limit, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/users/`,
				getRequestConfig(id, {
					limit: limit,
				})
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	retrieveCurrentUserCall = (successCallback, history) => {
		//DONE
		this.handleRequest(
			axios.get(
				`${this.apiBaseUrl}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/users/current/`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);

				// Exceptional handling for invalid token
				if (error?.response?.status === 403) {
					//clearUserSession('invalidToken', undefined, history);
				} else {
					////handleIfUnauthorized(error, history);
				}
			}
		);
	};

	issueTemplateRefreshRequestCall = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/templates/refresh/issue/`,
				{},
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	checkTemplateRefreshStatusCall = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/templates/refresh/status/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	listTemplatesCall = (cancelToken, successCallback, errorCallback) => {
		//DONE
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/templates/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	listSavedResponsesCall = (successCallback) => {
		//DONE
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/saved_responses/`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	createSavedResponseCall = (text, successCallback) => {
		//DONE
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/saved_responses/`,
				{
					text: text,
				},
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	deleteSavedResponseCall = (id, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/saved_responses/${id}/`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	resolveContactCall = (personWaId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/contacts/${personWaId}`,
				getRequestConfig(id)
			),
			successCallback,
			errorCallback
		);
	};

	listContactsCall = (search, limit, pages, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/contacts/`,
				getRequestConfig(
					id,
					{
						search: search,
						limit: limit,
						pages: pages,
					},
					cancelToken
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	listTagsCall = (successCallback) => {
		//Done
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/tags/`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	retrievePersonCall = (waId, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/contacts/${waId}/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	listMessagesCall = (
		waId,
		search,
		chatTagId,
		limit,
		offset,
		beforeTime,
		sinceTime,
		cancelToken,
		successCallback,
		errorCallback,
		history
	) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/messages/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						search: search,
						tag_id: chatTagId,
						offset: offset ?? 0,
						before_time: beforeTime,
						since_time: sinceTime,
						limit: limit,
					},
					cancelToken
				)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
				//handleIfUnauthorized(error, history);
			}
		);
	};

	listChatAssignmentEventsCall = (waId, beforeTime, sinceTime, cancelToken, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_assignment_events/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						before_time: beforeTime,
						since_time: sinceTime,
					},
					cancelToken
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	listChatTaggingEventsCall = (waId, beforeTime, sinceTime, cancelToken, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_tagging_events/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						before_time: beforeTime,
						since_time: sinceTime,
					},
					cancelToken
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	searchMessagesCall = (waId, search, limit, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/messages/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						search: search,
						limit: limit,
					},
					cancelToken
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	sendMessageCall = (body, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/messages/`,
				body,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	uploadMediaCall = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/media/`,
				formData,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				if (error?.response?.status === 413) {
					window.displayCustomError('The media file is too big to upload!');
				} else {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};

	markAsReceivedCall = (waId, timestamp, cancelToken, successCallback, errorCallback, history) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/mark_as_received/`,
				{
					customer_wa_id: waId,
					timestamp: timestamp,
				},
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//handleIfUnauthorized(error, history);
			}
		);
	};

	retrieveChatCall = (waId, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chats/${waId}/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	createChatTaggingCall = (waId, chatTaggingId, successCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_tagging/`,
				{
					chat: waId,
					tag: chatTaggingId,
				},
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	deleteChatTaggingCall = (chatTaggingId, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_tagging/${chatTaggingId}`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	listPersonsCall = (search, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/persons/`,
				getRequestConfig(
					id,
					{
						search: search,
					},
					cancelToken
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveChatAssignmentCall = (waId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_assignment/${waId}/`,
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				if (error?.response?.status !== 403) {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};

	updateChatAssignmentCall = (
		waId,
		assignedToUser,
		assignedGroup,
		successCallback,
		errorCallback
	) => {
		this.handleRequest(
			axios.put(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_assignment/${waId}/`,
				{
					wa_id: waId,
					assigned_to_user: assignedToUser,
					assigned_group: assignedGroup,
				},
				getRequestConfig(id)
			),
			successCallback,
			(error) => {
				if (error?.response?.status !== 403) {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};

	partialUpdateChatAssignmentCall = (
		waId,
		assignedToUser,
		assignedGroup,
		cancelToken,
		successCallback,
		errorCallback
	) => {
		const data = {
			wa_id: waId,
		};

		if (assignedToUser !== undefined) {
			data.assigned_to_user = assignedToUser;
		}

		if (assignedGroup !== undefined) {
			data.assigned_group = assignedGroup;
		}

		this.handleRequest(
			axios.patch(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/chat_assignment/${waId}/`,
				data,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	listGroupsCall = (cancelToken?, successCallback?, errorCallback?) => {
		this.handleRequest(
			`${this.apiBaseURL}${apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID}/groups/`,
			successCallback,
			errorCallback
		);
	};

	verifyContactsCall = (contacts, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/contacts/verify/`,
				{
					blocking: 'wait',
					contacts: contacts,
					force_check: true,
				},
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveBusinessProfileCall = (cancelToken, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/business/profile/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	updateBusinessProfileCall = (
		address,
		description,
		email,
		vertical,
		websites,
		cancelToken,
		successCallback,
		errorCallback
	) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/business/profile/`,
				{
					address: address,
					description: description,
					email: email,
					vertical: vertical,
					websites: Object.values(websites),
				},
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveProfileAboutCall = (cancelToken, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/profile/about/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	updateProfileAboutCall = (about, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/profile/about/`,
				{
					text: about,
				},
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveProfilePhotoCall = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/profile/photo/`,
				getRequestConfig(id, undefined, cancelToken, 'arraybuffer')
			),
			successCallback,
			errorCallback
		);
	};

	updateProfilePhotoCall = (formData, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/profile/photo/`,
				formData,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	deleteProfilePhotoCall = (cancelToken, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/settings/profile/photo/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	retrieveBulkMessageTaskElementsCall = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURL}${
					apiConfig?.bussinessId || window?.config?.X_BUSSINESS_ID
				}/bulk_message_elements/`,
				getRequestConfig(id, undefined, cancelToken)
			),
			successCallback,
			errorCallback
		);
	};

	//V2 Api's
	loginCallV2 = (username, password, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(`${this.apiBaseURLV2}auth/token/`, {
				username: username,
				password: password,
			}),
			successCallback,
			errorCallback
		);
	};

	getUsersOrganization = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}auth/organizations`,
				getRequestConfig(id, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};
	getRestaurants = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}restaurants`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};

	logoutCallV2 = (successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}auth/logout/`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	changePasswordCallV2 = (currentPassword, newPassword, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}auth/password/change/`,
				{
					current_password: currentPassword,
					new_password: newPassword,
				},
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	listChatsCallV2 = (
		keyword,
		chatTagId,
		limit,
		offset,
		assignedToMe,
		assignedGroup,
		cancelToken,
		successCallback,
		errorCallback,
		history,
		id
	) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}chats/`,
				getRequestConfig(
					id,
					{
						search: keyword,
						tag_id: chatTagId,
						limit: limit,
						offset: offset,
						assigned_to_me: assignedToMe,
						assigned_group: assignedGroup,
					},
					cancelToken,
					undefined,
					0,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				//handleIfUnauthorized(error, history);
				errorCallback?.(error);
			}
		);
	};
	bulkSendCallV2 = (body, successCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}messages/bulk`,
				body,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	listHiddenChatsCallV2 = (
		keyword,
		chatTagId,
		limit,
		offset,
		assignedToMe,
		assignedGroup,
		cancelToken,
		successCallback,
		errorCallback,
		history
	) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}chats/hidden`,
				getRequestConfig(
					id,
					{
						search: keyword,
						tag_id: chatTagId,
						limit: limit,
						offset: offset,
						assigned_to_me: assignedToMe,
						assigned_group: assignedGroup,
					},
					cancelToken,
					undefined,
					0,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				//handleIfUnauthorized(error, history);
				errorCallback?.(error);
			}
		);
	};
	bulkSendCallV2 = (body, successCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}messages/bulk`,
				body,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	listUsersCallV2 = (limit, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/`,
				getRequestConfig(
					id,
					{
						limit: limit,
					},
					null,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	retrieveCurrentUserCallV2 = (successCallback, errorCallback, history, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/current/`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				////window.displayError(error);
				errorCallback();
				// Exceptional handling for invalid token
				if (error?.response?.status === 403) {
					//clearUserSession('invalidToken', undefined, history);
				} else {
					////handleIfUnauthorized(error, history);
				}
			}
		);
	};

	issueTemplateRefreshRequestCallV2 = (cancelToken, successCallback, errorCallback) => {
		// this.handleRequest(
		// 	axios.post(
		// 		`${this.apiBaseURLV2}${
		// 			this.getBusinessId() || apiConfig?.bussinessId
		// 		}/templates/refresh/issue/`,
		// 		{},
		// 		getRequestConfig(id,undefined, cancelToken, undefined, undefined, true)
		// 	),
		// 	successCallback,
		// 	errorCallback
		// );
		successCallback();
	};

	checkTemplateRefreshStatusCallV2 = (cancelToken, successCallback, errorCallback) => {
		// this.handleRequest(
		// 	axios.get(
		// 		`${this.apiBaseURLV2}${
		// 			this.getBusinessId() || apiConfig?.bussinessId
		// 		}/templates/refresh/status/`,
		// 		getRequestConfig(id,undefined, cancelToken, undefined, undefined, true)
		// 	),
		// 	successCallback,
		// 	errorCallback
		// );
		successCallback();
	};

	listTemplatesCallV2 = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}template/`,
				getRequestConfig(id, undefined, cancelToken, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};

	listSavedResponsesCallV2 = (successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}saved-response/`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	createSavedResponseCallV2 = (text, successCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}saved-response/`,
				{
					text: text,
				},
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	deleteSavedResponseCallV2 = (id, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/saved-response/${id}/`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	resolveContactCallV2 = (personWaId, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/persons/${personWaId}`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	listContactsCallV2 = (search, limit, pages, cancelToken, successCallback, errorCallback) => {
		return successCallback();
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}persons/`,
				getRequestConfig(
					id,
					{
						search: search,
						limit: limit,
						pages: pages,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	listTagsCallV2 = (successCallback) => {
		this.handleRequest(
			axios.get(`${this.apiBaseURLV2}tags/`, getRequestConfig(id, null, null, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	retrievePersonCallV2 = (waId, cancelToken, successCallback, errorCallback, id) => {
		// return successCallback();
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/persons/${waId}/`,
				getRequestConfig(id, null, cancelToken, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	listMessagesCallV2 = (
		waId,
		search,
		chatTagId,
		limit,
		offset,
		beforeTime,
		sinceTime,
		cancelToken,
		successCallback,
		errorCallback,
		history,
		id
	) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}messages/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						restaurantId: id,
						search: search,
						tag_id: chatTagId,
						offset: offset ?? 0,
						before_time: beforeTime,
						since_time: sinceTime,
						limit: limit,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
				//handleIfUnauthorized(error, history);
			}
		);
	};

	listChatAssignmentEventsCallV2 = (
		waId,
		beforeTime,
		sinceTime,
		cancelToken,
		successCallback,
		errorCallback
	) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/chat-assignment/events/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						before_time: beforeTime,
						since_time: sinceTime,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	listChatTaggingEventsCallV2 = (
		waId,
		beforeTime,
		sinceTime,
		cancelToken,
		successCallback,
		errorCallback
	) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/chat-tagging/events/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						before_time: beforeTime,
						since_time: sinceTime,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	searchMessagesCallV2 = (waId, search, limit, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}messages/`,
				getRequestConfig(
					id,
					{
						wa_id: waId,
						search: search,
						limit: limit,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	sendMessageCallV2 = (body, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}messages/`,
				body,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	uploadMediaCallV2 = (formData, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}media/`,
				formData,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				if (error?.response?.status === 413) {
					window.displayCustomError('The media file is too big to upload!');
				} else {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};
	uploadDocumentCallV2 = (formData, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}media/document`,
				formData,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				if (error?.response?.status === 413) {
					window.displayCustomError('The media file is too big to upload!');
				} else {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};

	markAsReceivedCallV2 = (
		waId,
		timestamp,
		cancelToken,
		successCallback,
		errorCallback,
		history,
		id
	) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}messages/mark_as_received/`,
				{
					customer_wa_id: waId,
					timestamp: timestamp,
					restaurantId: id,
				},
				getRequestConfig(id, null, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//handleIfUnauthorized(error, history);
			}
		);
	};

	retrieveChatCallV2 = (waId, cancelToken, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}chats/${waId}`,
				getRequestConfig(id, null, cancelToken, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	createChatTaggingCallV2 = (waId, chatTaggingId, successCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}chat-tagging/`,
				{
					chat: waId,
					tag: chatTaggingId,
				},
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	deleteChatTaggingCallV2 = (chatTaggingId, waId, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/chat-tagging/${chatTaggingId}`,
				getRequestConfig(id, null, null, null, null, true, { chat: waId })
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	createTagV2 = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}tags/`,
				data,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	updateTagV2 = (tagId, data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}tags/${tagId}`,
				data,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	deleteTagV2 = (tagId, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}tags/${tagId}`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	listPersonsCallV2 = (search, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}persons/`,
				getRequestConfig(
					id,
					{
						search: search,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveChatAssignmentCallV2 = (waId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/chat-assignment/${waId}/`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				if (error?.response?.status !== 403) {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};

	updateChatAssignmentCallV2 = (
		waId,
		assignedToUser,
		assignedGroup,
		successCallback,
		errorCallback
	) => {
		this.handleRequest(
			axios.put(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/chat-assignment/${waId}/`,
				{
					wa_id: waId,
					assigned_to_user: assignedToUser,
					assigned_group: assignedGroup,
				},
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				if (error?.response?.status !== 403) {
					//window.displayError(error);
				}
				errorCallback?.(error);
			}
		);
	};

	partialUpdateChatAssignmentCallV2 = (
		waId,
		assignedToUser,
		assignedGroup,
		successCallback,
		errorCallback
	) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}${
					this.getBusinessId() || apiConfig?.bussinessId
				}/chat-assignment/${waId}/`,
				{
					assigned_to_user: assignedToUser,
					assigned_group: assignedGroup,
				},
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	assignMeToChatCallV2 = (waId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}chat_assignment/${waId}/assign_me/`,
				null,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	unassignMeFromChatCallV2 = (waId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}chat_assignment/${waId}/unassign_me/`,
				null,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveBulkMessageTaskElementsCallV2 = (taskId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}messages/bulk/`,
				getRequestConfig(id, null, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	listGroupsCallV2 = (cancelToken?, successCallback?, errorCallback?) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}groups/`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	verifyContactsCallV2 = (contacts, cancelToken, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}contact/verify/`,
				{
					blocking: 'wait',
					contacts: contacts,
					force_check: true,
				},
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveBusinessProfileCallV2 = (cancelToken, successCallback, errorCallback, id) => {
		console.log(id);
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}profile/`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback();
				//window.displayError(error);
			}
		);
	};

	updateBusinessProfileCallV2 = (
		address,
		description,
		email,
		vertical,
		websites,
		cancelToken,
		successCallback,
		errorCallback,
		id
	) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}profile/`,
				{
					address: address,
					description: description,
					email: email,
					vertical: vertical,
					websites: Object.values(websites),
				},
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveProfileAboutCallV2 = (cancelToken, successCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}profile/about/`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	updateProfileAboutCallV2 = (about, cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}profile/about/`,
				{
					text: about,
				},
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	retrieveProfilePhotoCallV2 = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}profile/photo`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	deleteProfilePhotoCallV2 = (cancelToken, successCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}profile/photo/`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
			}
		);
	};

	retrieveBulkMessageTaskElementsCallV2 = (cancelToken, successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}messages/bulk_message_elements/`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	getMqttPresignedUrl = (cancelToken, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}mqtt/presigned-url/`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			errorCallback
		);
	};

	//Cheeni Api's
	generateOTP = (phoneNumber, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(`${this.apiBaseURLV2}auth/generate/otp`, {
				phone: phoneNumber,
			}),
			successCallback,
			errorCallback
		);
	};

	loginCall = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(`${this.apiBaseURLV2}auth/login`, data),
			successCallback,
			errorCallback
		);
	};

	signUpCall = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(`${this.apiBaseURLV2}auth/signup`, data),
			successCallback,
			errorCallback
		);
	};

	getMasterCatalogs = (cancelToken, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}catalog`,
				getRequestConfig(
					id,
					{
						isMaster: true,
					},
					cancelToken,
					null,
					null,
					true
				)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getCatalogs = (cancelToken, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}catalog`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	createCatalog = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}catalog`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	createMasterCatalog = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}catalog/master`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	updateCatalog = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.put(
				`${this.apiBaseURLV2}catalog`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	addProducts = (data, successCallback, errorCallback, catalogId) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}catalog/items/${catalogId}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	deleteProducts = (productIds, successCallback, errorCallback, catalogId) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}catalog/items/${catalogId}`,
				getRequestConfig(null, null, null, null, null, true, { productIds: productIds })
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	editProducts = (data, successCallback, errorCallback, catalogId) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}catalog/items/${catalogId}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				console.log('2:5');
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getCatalogProducts = (successCallback, errorCallback, catalogId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}catalog/items/${catalogId}`,
				getRequestConfig(undefined, undefined, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getAllProducts = (cancelToken, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}suppliers/products/${this?.getSupplierId()}`,
				getRequestConfig(id, undefined, cancelToken, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getSupplierCustomers = (successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}catalog/customers`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	getSupplierProducts = (successCallback, errorCallback, supplierWaId, id, params) => {
		const queryParams = {};
		queryParams.page = params?.page || 1;
		queryParams.limit = params?.limit || 25;

		if (params?.category) {
			queryParams.category = params.category;
		}
		if (params?.search) {
			queryParams.search = params.search;
		}
		if (params?.machineModel) {
			queryParams.machineModel = params.machineModel;
		}
		if (params?.subCategory) {
			queryParams.subCategory = params.subCategory;
		}
		if (params?.machineBrand) {
			queryParams.machineBrand = params.machineBrand;
		}
		if (params?.dimension) {
			queryParams.dimension = params.dimension;
		}
		if (params?.design) {
			queryParams.design = params.design;
		}
		if (params?.weight) {
			queryParams.weight = params.weight;
		}
		if (params?.composition) {
			queryParams.composition = params.composition;
		}
		if (params?.brand) {
			queryParams.brand = params?.brand;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order-book/products/${supplierWaId}`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	addItemsToOrderbook = (data, successCallback, errorCallback, supplierWaId, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}order-book/${supplierWaId}`,
				data,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	getOrderBook = (successCallback, errorCallback, supplierWaId, id, params) => {
		const queryParams = {};
		queryParams.page = params?.page || 1;
		queryParams.limit = params?.limit || 25;

		if (params?.category) {
			queryParams.category = params.category;
		}
		if (params?.search) {
			queryParams.search = params.search;
		}
		if (params?.machineModel) {
			queryParams.machineModel = params.machineModel;
		}
		if (params?.subCategory) {
			queryParams.subCategory = params.subCategory;
		}
		if (params?.machineBrand) {
			queryParams.machineBrand = params.machineBrand;
		}
		if (params?.dimension) {
			queryParams.dimension = params.dimension;
		}
		if (params?.design) {
			queryParams.design = params.design;
		}
		if (params?.weight) {
			queryParams.weight = params.weight;
		}
		if (params?.composition) {
			queryParams.composition = params.composition;
		}
		if (params?.brand) {
			queryParams.brand = params?.brand;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order-book/${supplierWaId}`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	removeItemsFromOrderBook = (data, successCallback, errorCallback, supplierWaId, id) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}order-book/${supplierWaId}`,
				getRequestConfig(id, undefined, undefined, null, null, true, { productIds: data })
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	getOrderbookItems = (successCallback, errorCallback, supplierWaId, id, params) => {
		const queryParams = {};
		queryParams.page = params?.page || 1;
		queryParams.limit = params?.limit || 25;

		if (params?.category) {
			queryParams.category = params.category;
		}
		if (params?.search) {
			queryParams.search = params.search;
		}
		if (params?.machineModel) {
			queryParams.machineModel = params.machineModel;
		}
		if (params?.subCategory) {
			queryParams.subCategory = params.subCategory;
		}
		if (params?.machineBrand) {
			queryParams.machineBrand = params.machineBrand;
		}
		if (params?.dimension) {
			queryParams.dimension = params.dimension;
		}
		if (params?.design) {
			queryParams.design = params.design;
		}
		if (params?.weight) {
			queryParams.weight = params.weight;
		}
		if (params?.composition) {
			queryParams.composition = params.composition;
		}
		if (params?.brand) {
			queryParams.brand = params?.brand;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/items/${supplierWaId}`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getAllRestaurantProducts = (successCallback, errorCallback, restaurantPhone, params) => {
		const queryParams = {};
		queryParams.page = params?.page || 1;
		queryParams.limit = params?.limit || 25;

		if (params?.category) {
			queryParams.category = params.category;
		}
		if (params?.search) {
			queryParams.search = params.search;
		}
		if (params?.machineModel) {
			queryParams.machineModel = params.machineModel;
		}
		if (params?.subCategory) {
			queryParams.subCategory = params.subCategory;
		}
		if (params?.machineBrand) {
			queryParams.machineBrand = params.machineBrand;
		}
		if (params?.dimension) {
			queryParams.dimension = params.dimension;
		}
		if (params?.design) {
			queryParams.design = params.design;
		}
		if (params?.weight) {
			queryParams.weight = params.weight;
		}
		if (params?.composition) {
			queryParams.composition = params.composition;
		}
		if (params?.brand) {
			queryParams.brand = params?.brand;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order-book/products/supplier/${restaurantPhone}`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};
	addCartItems = (
		data,
		successCallback,
		errorCallback,
		selectedBranchWaId,
		waId,
		isMarketplace = false
	) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}cart/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}cart/${waId}/${selectedBranchWaId}`;

		const queryParams = {};
		if (isMarketplace) {
			queryParams.isMarketplace = true;
		}
		this.handleRequest(
			axios.patch(url, data, getRequestConfig(undefined, queryParams, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	saveCartInfo = (data, successCallback, errorCallback, selectedBranchWaId, waId, id) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}cart/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}cart/${waId}/${selectedBranchWaId}`;
		this.handleRequest(
			axios.post(url, data, getRequestConfig(id, undefined, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	clearCartData = (data, successCallback, errorCallback, selectedBranchWaId, waId, id) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}cart/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}cart/${waId}/${selectedBranchWaId}`;
		this.handleRequest(
			axios.delete(
				url,
				getRequestConfig(id, undefined, undefined, null, null, true, { products: data })
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	createOrder = (
		data,
		successCallback,
		errorCallback,
		selectedBranchWaId,
		waId,
		isMarketplace = false
	) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}order/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}order/${waId}/${selectedBranchWaId}`;

		const queryParams = {};
		if (isMarketplace) {
			queryParams.isMarketplace = true;
		}

		this.handleRequest(
			axios.post(
				`${url}`,
				data,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	getCartData = (successCallback, errorCallback, selectedBranchWaId, waId, id) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}cart/${selectedBranchWaId}/${waId}?type=dropdown`
				: `${this.apiBaseURLV2}cart/${waId}/${selectedBranchWaId}?type=dropdown`;

		this.handleRequest(
			axios.get(url, getRequestConfig(id, undefined, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	//Order API's
	getOrderDetails = (successCallback, errorCallback, restaurantId, orderId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/${restaurantId}/${orderId}`,
				getRequestConfig(restaurantId, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getOrderStatuses = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/statuses`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getAllOrders = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			page: params?.page,
			limit: params?.limit,
		};
		if (params?.search) {
			queryParams.search = params?.search;
		}
		if (params?.from) {
			queryParams.from = params?.from;
		}
		if (params?.to) {
			queryParams.to = params?.to;
		}
		if (params?.status) {
			queryParams.status = params?.status;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getPendingOrders = (successCallback, errorCallback, restaurantId, params) => {
		const queryParams = {
			page: params?.page,
			limit: params?.limit,
		};
		if (params?.search) {
			queryParams.search = params?.search;
		}
		if (params?.from) {
			queryParams.from = params?.from;
		}
		if (params?.to) {
			queryParams.to = params?.to;
		}
		if (params?.status) {
			queryParams.status = params?.status;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/pending`,
				getRequestConfig(restaurantId, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	updateOrderStatus = (data, successCallback, errorCallback, cheeniOrderId) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}order/status/${cheeniOrderId}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	// Rewards apis start

	getAllRewards = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			page: params?.page,
			limit: params?.limit,
		};
		if (params?.search) {
			queryParams.search = params?.search;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}rewards`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	updateRedemptionSettings = (data, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}rewards/redemptionSettings`,
				data,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	deleteReward = (rewardId, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}rewards/${rewardId}`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	createReward = (data, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}rewards`,
				data,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getRewardTypes = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			rewardType: params.rewardType,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}rewards/rewardTypes`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getRewardDashboard = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			page: params?.page,
			limit: params?.limit,
		};
		if (params?.search) {
			queryParams.search = params?.search;
		}
		if (params?.from && params?.to) {
			queryParams.from = params?.from;
			queryParams.to = params?.to;
		}
		if (params?.restaurantId) {
			queryParams.restaurantId = params?.restaurantId;
		}
		if (params?.supplierId) {
			queryParams.supplierId = params?.supplierId;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}rewards/transactions`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getRewardOrganizations = (successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}rewards/organizations`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getCustomerWallet = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			page: params?.page,
			limit: params?.limit,
		};
		if (params?.search) {
			queryParams.search = params?.search;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}rewards/customers`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getCustomerWalletHistory = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			restaurantId: params?.id,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}rewards/bonusHistory`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	addBonusToWalletForCustomers = (data, successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}rewards/wallet`,
				data,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	// Rewards apis end

	getUnreadMessageCount = (successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}messages/unread`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	//Product Management

	uploadProductImage = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}products/image`,
				formData,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getProductCategories = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/category`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getPublicProductCategories = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/marketplace/categories`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getSubCategories = (successCallback, errorCallback, categoryId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/category/sub/${categoryId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getAttribute = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/attribute`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getTaxClasses = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/tax/classes`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getStockStatuses = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/stock/statuses`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getProducts = (successCallback, errorCallback, params) => {
		const queryParams = {};
		queryParams.page = params?.page || 1;
		queryParams.limit = params?.limit || 25;

		if (params?.category) {
			queryParams.category = params.category;
		}
		if (params?.search) {
			queryParams.search = params.search;
		}
		if (params?.machineModel) {
			queryParams.machineModel = params.machineModel;
		}
		if (params?.subCategory) {
			queryParams.subCategory = params.subCategory;
		}
		if (params?.machineBrand) {
			queryParams.machineBrand = params.machineBrand;
		}
		if (params?.dimension) {
			queryParams.dimension = params.dimension;
		}
		if (params?.design) {
			queryParams.design = params.design;
		}
		if (params?.weight) {
			queryParams.weight = params.weight;
		}
		if (params?.composition) {
			queryParams.composition = params.composition;
		}
		if (params?.brand) {
			queryParams.brand = params?.brand;
		}

		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	createProduct = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}products`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	bulkProductCreation = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}products`,
				formData,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	validateCSV = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}products/csv/validate`,
				formData,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	updateProduct = (data, successCallback, errorCallback, productId) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}products/${productId}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	deleteCatalogsProducts = (productIds, successCallback, errorCallback) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}products`,
				getRequestConfig(null, null, null, null, null, true, { productIds: productIds })
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	updateProductMaxLimit = (data, successCallback, errorCallback, supplierWaId, id) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}order-book/${supplierWaId}`,
				data,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	//Public Page Api's
	sendOTPOrderPage = (successCallback, errorCallback, instanceId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/order/verify/${instanceId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	verifyOTPOrderPage = (data, successCallback, errorCallback, instanceId) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}public/order/verify/${instanceId}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getOrdersDetailsPublicPage = (successCallback, errorCallback, instanceId, token) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/order/details/${instanceId}/${token}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	updateOrder = (data, successCallback, errorCallback, id, cheeniOrderId) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}order/${cheeniOrderId}`,
				data,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getOrderStatus = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/statuses`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getOrderHistory = (successCallback, errorCallback, id, cheeniOrderId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/history/${cheeniOrderId}`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getAllSuppliers = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}suppliers`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};
	//Users Calls
	updateProfilePhotoCallV2 = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}users/photo`,
				formData,
				getRequestConfig(null, undefined, null, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	updateProfile = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}users`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getUsers = (successCallback, errorCallback, params) => {
		const queryParams = {};
		queryParams.page = params?.page || 1;
		queryParams.limit = params?.limit || 25;
		if (params?.search) {
			queryParams.name = params?.search;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}teams`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	createUser = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}teams`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	recoverUser = (data, successCallback, errorCallback, phone) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}teams/recover/${phone}`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	editUser = (data, successCallback, errorCallback, phone) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}teams/${phone}`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	uploadProfileImage = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}teams/image`,
				formData,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	deleteUser = (successCallback, errorCallback, phone) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}teams/${phone}`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};

	getMyPermissions = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/permission`,
				getRequestConfig(undefined, null, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	checkPhoneNumberAvailability = (successCallback, errorCallback, phone) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}teams/check/${phone}`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};
	//Permissions
	getAllPermissions = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}permission/all`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};

	getUserPermissions = (successCallback, errorCallback, phone) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}permission/${phone}`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};

	setUserPermissions = (data, successCallback, errorCallback, phone) => {
		this.handleRequest(
			axios.put(
				`${this.apiBaseURLV2}permission/${phone}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};
	//Branches
	getBranches = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}branches`,
				getRequestConfig(undefined, null, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};
	createBranch = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}branches`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};
	uploadBranchImage = (formData, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}branches/image`,
				formData,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};
	editBranch = (data, successCallback, errorCallback, branchId) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}branches/${branchId}`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	deleteBranch = (successCallback, errorCallback, branchId) => {
		this.handleRequest(
			axios.delete(
				`${this.apiBaseURLV2}branches/${branchId}`,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			errorCallback
		);
	};

	//Tally
	getIntegrations = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}integrations`,
				getRequestConfig(undefined, null, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};
	generateTallyCredentials = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}integrations/generate/credentials/tally`,
				getRequestConfig(undefined, null, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	updateTallyStatus = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}integrations`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	//Delivery Acceptance
	getProductsByOrderId = (successCallback, errorCallback, orderId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/products/${orderId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	updateOrderProduct = (data, successCallback, errorCallback, productId) => {
		this.handleRequest(
			axios.patch(
				`${this.apiBaseURLV2}order/products/${productId}`,
				data,
				getRequestConfig(null, undefined, undefined, undefined, undefined, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	confirmOrderProducts = (successCallback, errorCallback, cheeniOrderId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/delivery/check/${cheeniOrderId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	//Finance Feature
	checkEligiblity = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}finance/eligibility`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	connectERP = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}integrations/connect/erp`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	generateQUrl = (successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/generate/q-url`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	generateDashboardUrl = (successCallback, errorCallback, id) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}users/generate/dashboard-url`,
				getRequestConfig(id, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	//MarketPlace
	getProductCategories = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}marketplace/categories`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getSuggestedSuppliers = (successCallback, errorCallback, params = {}) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}marketplace/suppliers`,
				getRequestConfig(undefined, params, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getMarketPlaceProducts = (successCallback, errorCallback, params) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}marketplace/products`,
				getRequestConfig(undefined, params, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getPublicMarketPlaceProducts = (successCallback, errorCallback, params) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/marketplace/products`,
				getRequestConfig(undefined, params, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getSupplierIdFromSlug = (successCallback, errorCallback, slug) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/marketplace/supplier/${slug}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	addCartItemsMarketplace = (
		data,
		successCallback,
		errorCallback,
		selectedBranchWaId,
		waId,
		isMarketplace = false
	) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}marketplace/cart/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}marketplace/cart/${waId}/${selectedBranchWaId}`;

		const queryParams = {};
		if (isMarketplace) {
			queryParams.isMarketplace = true;
		}
		this.handleRequest(
			axios.patch(url, data, getRequestConfig(undefined, queryParams, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	saveCartInfoMarketplace = (data, successCallback, errorCallback, selectedBranchWaId, waId) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}marketplace/cart/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}marketplace/cart/${waId}/${selectedBranchWaId}`;
		this.handleRequest(
			axios.post(url, data, getRequestConfig(undefined, undefined, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	clearCartDataMarketplace = (data, successCallback, errorCallback, selectedBranchWaId, waId) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}marketplace/cart/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}marketplace/cart/${waId}/${selectedBranchWaId}`;
		this.handleRequest(
			axios.delete(
				url,
				getRequestConfig(undefined, undefined, undefined, null, null, true, { products: data })
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	createOrderMarketplace = (
		data,
		successCallback,
		errorCallback,
		selectedBranchWaId,
		waId,
		isMarketplace = false
	) => {
		const url =
			this.getCurrentUserType() === RESTAURANT
				? `${this.apiBaseURLV2}marketplace/order/${selectedBranchWaId}/${waId}`
				: `${this.apiBaseURLV2}marketplace/order/${waId}/${selectedBranchWaId}`;

		const queryParams = {};
		if (isMarketplace) {
			queryParams.isMarketplace = true;
		}

		this.handleRequest(
			axios.post(
				`${url}`,
				data,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	getCartDataMarketplace = (successCallback, errorCallback, selectedBranchWaId, waId) => {
		const url = `${this.apiBaseURLV2}marketplace/cart/${selectedBranchWaId}`;

		this.handleRequest(
			axios.get(url, getRequestConfig(undefined, undefined, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getCitiesForMarketplaceSuppliers = (successCallback, errorCallback) => {
		const url = `${this.apiBaseURLV2}marketplace/cities`;

		this.handleRequest(
			axios.get(url, getRequestConfig(undefined, undefined, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getPublicCitiesForMarketplaceSuppliers = (successCallback, errorCallback) => {
		const url = `${this.apiBaseURLV2}public/marketplace/cities`;

		this.handleRequest(
			axios.get(url, getRequestConfig(undefined, undefined, undefined, null, null, true)),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	getApprovalRequestList = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}integrations/tally/approvals`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	approveRestaurant = (successCallback, errorCallback, restaurantId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}integrations/tally/approvals/${restaurantId}/accept`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};
	rejectRestaurant = (successCallback, errorCallback, restaurantId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}integrations/tally/approvals/${restaurantId}/reject`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError('Something went wrong!');window.displayError('Something went wrong!');
				errorCallback?.(error);
			}
		);
	};

	//Storefront Api's
	checkSlugAvailability = (data, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}branches/slug/availability`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getSupplierBySlug = (successCallback, errorCallback, slug) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/marketplace/supplier/${slug}`,
				data,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	updateOneSignalId = (subscriptionId, successCallback, errorCallback) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}users/onesignal/${subscriptionId}`,
				{},
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getGroups = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/group/category`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getCategories = (successCallback, errorCallback, groupId) => {
		const queryParams = {};
		if (groupId) {
			queryParams.groupId = groupId;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/category`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getSubCategories = (successCallback, errorCallback, categoryId) => {
		const queryParams = {};
		if (categoryId) {
			queryParams.categoryId = categoryId;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/category/sub`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getBrands = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/brand`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getManufacturers = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/manufacturer`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getModels = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/model`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getOwnerships = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/ownership`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getDimensions = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/dimension`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getDiameters = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/diameter`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getDesigns = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/design`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getQualities = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/quality`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getPerformances = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/performance`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getCompositions = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/composition`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getWeights = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}products/util/weight`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	getPaymentOptions = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/payment-options`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};
	getPaymentHistory = (successCallback, errorCallback, orderId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/payment/${orderId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};
	capturePaymentDetails = (successCallback, errorCallback, orderId, requestBody) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}order/payment/${orderId}`,
				requestBody,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				//window.displayError(error);
				errorCallback?.(error);
			}
		);
	};

	// Credit limit apis start
	getCustomerList = (successCallback, errorCallback, id, params) => {
		const queryParams = {
			page: params?.page,
			limit: params?.limit,
		};
		if (params?.search) {
			queryParams.search = params?.search;
		}
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}credit-limit/customers`,
				getRequestConfig(id, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getCustomerOrders = (successCallback, errorCallback, customerId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/customerOrders/${customerId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getCreditLimit = (successCallback, errorCallback, customerId) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}credit-limit/${customerId}`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	updateCreditLimit = (successCallback, errorCallback, restaurantId, requestBody) => {
		this.handleRequest(
			axios.post(
				`${this.apiBaseURLV2}credit-limit/${restaurantId}`,
				requestBody,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	exportCustomerList = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}credit-limit/export`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	// Credit limit apis end

	// Register Page apis start

	getStatesList = (successCallback, errorCallback, searchTerm) => {
		const queryParams = {
			name: searchTerm,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/metadata/states`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getDistrictsList = (successCallback, errorCallback, stateId) => {
		const queryParams = {
			stateId: stateId,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/metadata/districts`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getCitiesList = (successCallback, errorCallback, districtId) => {
		const queryParams = {
			districtId: districtId,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/metadata/cities`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getMachineBrands = (successCallback, errorCallback, name) => {
		const queryParams = {
			name: name,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/metadata/brands`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getMachineModels = (successCallback, errorCallback, name) => {
		const queryParams = {
			name: name,
		};
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/metadata/models`,
				getRequestConfig(undefined, queryParams, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	getAllSuppliersList = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}public/metadata/suppliers`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};

	// Register Page apis end

	getOrderMetadata = (successCallback, errorCallback) => {
		this.handleRequest(
			axios.get(
				`${this.apiBaseURLV2}order/metadata`,
				getRequestConfig(undefined, undefined, undefined, null, null, true)
			),
			successCallback,
			(error) => {
				errorCallback?.(error);
			}
		);
	};
}
